<template>
  <div class="page-title"  :class="{ 'page-title--left': left }">
    <div class="page-title__main">
      <div class="container">
        <p v-if="pageTitle" class="page-title__title">{{ $t(pageTitle) }}</p>
        <p v-if="pageContent" class="page-title__content" v-html="$t(pageContent)" />
      </div>
    </div>

    <div class="page-title__breadcrumb">
      <div class="container">
        <nav v-if="breadcrumb" aria-label="breadcrumb">
          <ol class="breadcrumb__list">
            <li
              class="breadcrumb__item"
              :class="{ active: currentPage === item.title }"
              v-for="(item, index) in breadcrumbItem"
              :key="'breadcrumbItem' + index"
            >
              <router-link
                :to="{
                  name: item.title === 'route.title.memberCenter' ? '' : item.name,
                  params: item.params,
                }"
              >
                {{ $t(item.title) }}
              </router-link>
            </li>
          </ol>
        </nav>

        <slot v-if="breadcrumbSlot" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['english', 'title', 'content', 'left', 'breadcrumb', 'currentPage', 'breadcrumbSlot'],
  created() {
    this.SetData();
  },
  data() {
    return {
      current: [],
      breadcrumbItem: [],
    };
  },
  computed: {
    pageTitle() {
      if (this.title) {
        return this.title;
      }

      if (this.$route.meta.title) {
        return this.$route.meta.title;
      }

      return this.currentPage.title;
    },
    pageEnglish() {
      return this.english ?? this.$route.meta.english;
    },
    pageContent() {
      return this.content ?? this.$route.meta.content;
    },
  },
  watch: {
    $route() {
      this.current = [];
      this.SetData();
    },
    currentPage() {
      this.current = this.currentPage;
      this.SetData();
    },
  },
  methods: {
    SetData() {
      if (!this.breadcrumb) {
        return;
      }

      const data = this.$route.path.toLowerCase().split('/');

      const test = this._.filter(
        this.$router.options.routes,
        (o) => this._.indexOf(data, o.name.toLowerCase()) >= 0,
      );

      this.breadcrumbItem = this._.map(test, (o) => ({
        name: o.name,
        title: o.meta.title,
        path: o.path,
        params: {},
      }));

      // 如果目前網址的路由名字不為空白，則統一小寫 (這邊是從頁面傳送過來，並非路由本身)
      const currentToLow = this._.map(this.current, (o) => (o.name === undefined ? '' : o.name.toLowerCase()));

      // 原本路由跟目頁面傳送過來的比對，如果已經存在於頁面傳來的，則保留頁面傳來的(因為頁面傳來的會有動態的標題名稱)
      const keepRoute = this._.filter(
        this.breadcrumbItem,
        (o) => this._.indexOf(currentToLow, o.name.toLowerCase()) < 0,
      );
      // 當前路由超過1個節點時，才需要加上後續路由
      if (data.length - 1 >= 2) this.breadcrumbItem = keepRoute.concat(this.current);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
